import React, { useRef, useState, useCallback, useEffect } from 'react';
import ScrollBooster from 'scrollbooster';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/**
 * Returns ref values for the viewport and the scrollbooster instance
 */

var useScrollBoost = function useScrollBoost(options) {
  if (options === void 0) {
    options = {};
  }

  var scrollBooster = useRef(null);

  var _useState = useState(scrollBooster.current),
      scrollBoosterState = _useState[0],
      setScrollBoosterState = _useState[1]; // options shouldn't change within the hook but can be changed on the scrollBooster instance


  var optionsRef = useRef(options);
  var initScrollBoost = useCallback(function (node) {
    var _optionsRef$current = optionsRef.current,
        contentRef = _optionsRef$current.contentRef,
        rest = _objectWithoutPropertiesLoose(_optionsRef$current, ["contentRef", "viewportRef"]);

    var sbOptions = _extends({
      viewport: node
    }, rest);

    sbOptions.viewport = node;

    if (contentRef == null ? void 0 : contentRef.current) {
      sbOptions.content = contentRef.current;
    } // create the scrollbooster instance


    scrollBooster.current = new ScrollBooster(sbOptions);
    setScrollBoosterState(scrollBooster.current);
  }, []);
  var viewport = useCallback(function (node) {
    if (node) {
      if (options.viewportRef) {
        // eslint-disable-next-line no-param-reassign
        options.viewportRef.current = node;
        return;
      }

      initScrollBoost(node);
    }
  }, [initScrollBoost, options.viewportRef]);
  useEffect(function () {
    var _options$viewportRef;

    if ((_options$viewportRef = options.viewportRef) == null ? void 0 : _options$viewportRef.current) {
      initScrollBoost(options.viewportRef.current);
    }
  }, [initScrollBoost, options.viewportRef]);
  useEffect(function () {
    // clear the scrollbooster eventlisteners
    return function () {
      var _scrollBooster$curren;

      return (_scrollBooster$curren = scrollBooster.current) == null ? void 0 : _scrollBooster$curren.destroy();
    };
  }, []);
  return [viewport, scrollBoosterState];
};

function ScrollBoost(_ref) {
  var children = _ref.children,
      options = _objectWithoutPropertiesLoose(_ref, ["children"]);

  var _useScrollBoost = useScrollBoost(options),
      viewport = _useScrollBoost[0],
      scrollbooster = _useScrollBoost[1];

  return React.createElement(React.Fragment, null, children({
    viewport: viewport,
    scrollbooster: scrollbooster
  }));
}

export { ScrollBoost, useScrollBoost };
//# sourceMappingURL=react-scrollbooster.esm.js.map
